const inputs = {
  name: {
    id: 'name',
    name: 'name',
    input: 'textField',
    label: 'projectList.form.name.label',
    placeholder: 'projectList.form.name.placeholder',
    rules: {
      required: { value: true },
    },
  },
  description: {
    id: 'description',
    name: 'description',
    input: 'textField',
    placeholder: 'projectList.form.description.placeholder',
    label: 'projectList.form.description.label',
  },
  company: {
    id: 'company_id',
    name: 'company',
    input: 'select',
    label: 'projectList.form.company.label',
    rules: {
      required: { value: true },
    },
  },
  scmType: {
    id: 'type_scm',
    name: 'scmType',
    input: 'select',
    label: 'projectList.form.scmType.label',
    rules: {
      required: { value: true },
    },
  },
  folder: {
    id: 'base_url',
    name: 'folder',
    input: 'textField',
    placeholder: 'projectList.form.folder.placeholder',
    label: 'projectList.form.folder.label',
  },
  scmUrl: {
    id: 'url_scm',
    name: 'scmUrl',
    input: 'textField',
    label: 'projectList.form.scmUrl.label',
    placeholder: 'https://github.com/org/repo.git',
    rules: {
      required: { value: true, message: 'URL is required for Git SCM' },
    },
  },
  scmBranch: {
    id: 'branch_scm',
    name: 'scmBranch',
    input: 'textField',
    label: 'projectList.form.scmBranch.label',
    placeholder: 'HEAD',
  },
  scmRefspec: {
    id: 'refspec_scm',
    name: 'scmRefspec',
    input: 'textField',
    label: 'projectList.form.scmRefspec.label',
    placeholder: '+refs/heads/*:refs/remotes/origin/*',
  },
  credential: {
    id: 'credentials_id',
    name: 'credential',
    input: 'select',
    label: 'projectList.form.credential.label',
  },
  clean: {
    id: 'clean',
    name: 'clean',
    input: 'switch',
    label: 'projectList.form.clean.label',
  },
  deleteOnUpdate: {
    id: 'clear_update',
    name: 'deleteOnUpdate',
    input: 'switch',
    label: 'projectList.form.deleteOnUpdate.label',
  },
  allowBranchOverride: {
    id: 'allow_branch_override',
    name: 'allowBranchOverride',
    input: 'switch',
    label: 'projectList.form.allowBranchOverride.label',
  }
}

export default inputs;
